<template>
  <div class="icon-container">
    <el-icon class="icon-comp" :class="type">
      <SuccessFilled v-if="type === 'success'" />
      <WarningFilled v-else-if="type === 'warning'" />
      <CircleCloseFilled v-else-if="type === 'error'" />
      <QuestionFilled v-else-if="type === 'info'" />
      <QuestionFilled v-else />
    </el-icon>
  </div>
</template>

<script setup>
const props = defineProps({
  type: {
    type: String,
    default: "info",
  },
});

const typeColorMap = {
  success: '#42fda3',
  warning: '#ff6f28',
  info: '#5169ff',
  error: '#ed3a53'
}

const currColor = typeColorMap[props.type];
const successColor = typeColorMap.success;
const warningColor = typeColorMap.warning;
const infoColor = typeColorMap.info;
const errorColor = typeColorMap.error;

</script>

<style lang="scss" scoped>
.icon-container {
  & {
    width: 24px;
    height: 24px;
    line-height: 24px;
    border-radius: 50%;
  }

  .icon-comp {
    & {
      height: 24px;
      line-height: 24px;
      border-radius: 50%;
    }

    &::after {
      position: absolute;
      content: "";
      width: 12px;
      height: 12px;
      background-color: transparent;
      z-index: -1;
      border-radius: 50%;
      box-shadow: 0px 0px 10px 5px v-bind(currColor);
    }

    &.success {
      color: v-bind(successColor);
    }

    &.warning {
      color: v-bind(warningColor);
    }

    &.info {
      color: v-bind(infoColor);
    }

    &.error {
      color: v-bind(errorColor);
    }
  }

}

</style>